import React from 'react'
import estado_vacio from '../../../assets/images/empty-state.svg';

class ComponenteVacio extends React.Component {
    render() {
        return (
            <div className="empty-state">
                <img src={estado_vacio} className="img-fluid" alt="sin_elementos"/>
                    <span className="empty-msg"> No hay elementos para mostrar. </span>
            </div>
        )
    }
}

export default ComponenteVacio;
